/**
 * Build a createShift payload from an existing shift.
 * Assignments / tasks are not copied — the API creates empty slots from nb_volunteers.
 */
export function buildShiftDuplicatePayload(source, overrides = {}, fallbackApplicationTypeId = null) {
    if (!source)
        return null;

    const application_type_id = source.application_type_id
        || fallbackApplicationTypeId
        || null;
    const sector_id = overrides.sector_id ?? source.sector_id;
    const start_at = overrides.start_at ?? source.start_at;
    const stop_at = overrides.stop_at ?? source.stop_at;

    if (!application_type_id || !sector_id || !start_at || !stop_at)
        return null;

    const payload = {
        application_type_id,
        sector_id,
        start_at,
        stop_at,
        nb_volunteers: source.nb_volunteers ?? 0,
    };

    if (source.activity_id)
        payload.activity_id = source.activity_id;
    if (source.status)
        payload.status = source.status;

    const admin_ids = overrides.admin_ids
        ?? source.admin_ids
        ?? (source.admins || []).map(admin => admin.id).filter(Boolean);
    if (admin_ids?.length)
        payload.admin_ids = admin_ids;

    return payload;
}
